module.exports = __webpack_public_path__ + "img/message-notification-square.9184d0f9.svg";